import cx from 'classnames'
import _map from 'lodash-es/map'
import React, { Component, PropTypes, Children } from 'react'
import ReactDOM from 'react-dom'
import TetherComponent from 'react-tether'

import Card from '../Card'
import UIDropdownItem from '../UIDropdownItem'

import style from './style.styl'

class UIDropdown extends Component {
  static propTypes = {
    /** Element or string to display as title*/
    title: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
    ]).isRequired,

    /** List of objects of the form {text, value}*/
    children: PropTypes.node.isRequired,

    /** Function to be called on selecting an item: (value, event) => */
    onSelection: PropTypes.func,

    /** Aligment of the dropdown */
    attachment: PropTypes.string,
    targetAttachment: PropTypes.string,
    offset: PropTypes.string,

    /** Clasname to add to dropdown */
    className: PropTypes.string,

    /** Clasname to add to target */
    targetClassName: PropTypes.string,
  }

  static defaultProps = {
    alignment: 'left',
  }

  state = {
    open: false,
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true)
  }

  handleClickOutside = (e) => {
    try {
      const node = ReactDOM.findDOMNode(this)
      const cardNode = this.refs.UIDropdownCard

      if (!(node && node.contains(e.target)) && !(cardNode && cardNode.contains(e.target))) {
        this.setState({ open: false })
      }
    } catch (e) {
      // Some times componentWillUnmount seems to not be getting called. Ignore when this fails
    }
  }

  toggleDropdown = () => {
    const { open } = this.state
    this.setState({ open: !open })
  }

  render() {
    const {
      title,
      attachment,
      targetAttachment,
      offset,
      targetClassName,
    } = this.props

    return (
      <TetherComponent attachment={attachment}
                       targetAttachment={targetAttachment}
                       offset={offset}
      >
        <div className={targetClassName}
             onClick={this.toggleDropdown}>
          {title}
        </div>
        {this.renderDropdown()}
      </TetherComponent>
    )
  }

  renderDropdown() {
    const { children, className, onSelection } = this.props
    const { open } = this.state

    const items = _map(Children.toArray(children), (child, index) => {
      return React.cloneElement(child, {
        onSelection,
        toggleDropdown: this.toggleDropdown,
      })
    })

    if (open) {
      return (
        <div className={cx("uiDropdown", className)}>
          <div ref='UIDropdownCard'>
            {items}
          </div>
        </div>
      )
    }
  }
}

export default UIDropdown



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/UIDropdown/index.js